var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { attrs: { xs12: "", sm12: "", "pa-4": "", layout: "", wrap: "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "", sm6: "", md3: "" } },
        [
          _c("v-text-field", {
            attrs: {
              label: "Número Serie",
              clearable: "",
              "prepend-icon": "abc"
            },
            on: { change: _vm.handleFilters },
            model: {
              value: _vm.paramApi.serienumero,
              callback: function($$v) {
                _vm.$set(_vm.paramApi, "serienumero", $$v)
              },
              expression: "paramApi.serienumero"
            }
          })
        ],
        1
      ),
      _c(
        "v-flex",
        { attrs: { xs12: "", sm3: "", md3: "" } },
        [
          _c("v-autocomplete", {
            attrs: {
              label: "Equipo",
              items: _vm.filterApi.EQUIPOS,
              "item-text": "tipoeqname",
              "item-value": "tipoeqid",
              "return-object": "",
              clearable: "",
              "prepend-icon": "explore"
            },
            on: { change: _vm.handleFilters },
            model: {
              value: _vm.paramApi.equipo,
              callback: function($$v) {
                _vm.$set(_vm.paramApi, "equipo", $$v)
              },
              expression: "paramApi.equipo"
            }
          })
        ],
        1
      ),
      _c(
        "v-flex",
        { attrs: { xs12: "", sm3: "", md3: "" } },
        [
          _c("DatePicker", {
            attrs: {
              label: "Fecha Carga",
              "prepend-icon": "event_note",
              locale: "es-cl"
            },
            model: {
              value: _vm.paramApi.fechacarga,
              callback: function($$v) {
                _vm.$set(_vm.paramApi, "fechacarga", $$v)
              },
              expression: "paramApi.fechacarga"
            }
          })
        ],
        1
      ),
      _c(
        "v-flex",
        {
          attrs: {
            xs12: "",
            sm6: "",
            md3: "",
            layout: "",
            "justify-center": "",
            wrap: "",
            "mt-2": ""
          }
        },
        [
          _c(
            "v-btn",
            { on: { click: _vm.handleSearchFilter } },
            [
              _c("v-icon", { attrs: { color: "#27488e" } }, [_vm._v("search")]),
              _vm._v("Filtrar\n    ")
            ],
            1
          ),
          _c(
            "v-btn",
            {
              on: {
                click: function($event) {
                  return _vm.handleCleanFilters()
                }
              }
            },
            [
              _c("v-icon", { attrs: { color: "#27488e" } }, [_vm._v("clear")]),
              _vm._v("Limpiar\n    ")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }